import React, { useState, useEffect } from 'react';
import { withFormsy } from 'formsy-react';
import { pick } from 'lodash';
import { Checkbox } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { styled } from '@mui/material/styles';

const CustomTableContainer = styled(TableContainer)(() => ({
  border: '1px solid lightgrey',
  borderRadius: '10px',
  overflow: 'hidden',
}));

function TabularMultipleFormsy(props) {
  const importedProps = pick(props, ['onChange']);

  const { errorMessage, description, rowOptions, columnOptions, value } = props;

  function changeValue(event, val) {
    props.setValue(val);
    if (props.onChange) {
      props.onChange(event);
    }
  }

  const generateSelectedOptions = (data) => {
    const options = {};
    rowOptions.map((a) => {
      options[a.alias] = {};
      columnOptions.map((b) => {
        if (data && data.length > 0) {
          let count = 0;
          data.map((b) => {
            if (b.rowOptionAlias === a.alias) {
              count += 1;
              columnOptions.map((c) => {
                if (b.columnOptionAliases.includes(c.alias)) {
                  options[a.alias][c.alias] = true;
                } else {
                  options[a.alias][c.alias] = false;
                }
              });
            }
          });
          if (count === 0) {
            options[a.alias][b.alias] = false;
          }
        } else {
          options[a.alias][b.alias] = false;
        }
      });
    });
    return options;
  };

  let tempOptions = generateSelectedOptions(value);

  const [selectedOptions, setSelectedOptions] = useState(tempOptions);

  const width = 100 / (1 + columnOptions.length) + '%';

  const handleCheckboxChange = (event, row, column) => {
    const changedOption = {
      ...selectedOptions[row],
      [column]: !selectedOptions[row][column],
    };
    const newOptions = { ...selectedOptions, [row]: changedOption };
    setSelectedOptions(newOptions);
    processSelectedOptions(event, newOptions);
  };

  const processSelectedOptions = (event, options) => {
    const finalResponse = [];
    rowOptions.map((a) => {
      const responseObj = {
        RowOptionAlias: a.alias,
        RowOption: {
          Alias: a.alias,
          Label: a.label,
        },
        ColumnOptionAliases: [],
        ColumnOptions: [],
      };
      let count = 0;
      columnOptions.map((b) => {
        if (options[a.alias][b.alias]) {
          count += 1;
          responseObj.ColumnOptionAliases.push(b.alias);
          responseObj.ColumnOptions.push({
            Alias: b.alias,
            Label: b.label,
          });
        }
      });
      if (count > 0) {
        finalResponse.push(responseObj);
      }
    });
    changeValue(event, finalResponse);
  };

  return (
    <div>
      <p>{props.label}</p>
      <CustomTableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>&nbsp;</TableCell>
              {columnOptions.map((item) => (
                <TableCell key={item.alias} width={width}>
                  {item.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rowOptions.map((row) => (
              <TableRow key={row.alias}>
                <TableCell width={width}>{row.label}</TableCell>
                {columnOptions.map((column) => (
                  <TableCell width={width} key={column.alias}>
                    <Checkbox
                      checked={selectedOptions[row.alias][column.alias]}
                      onChange={(event) => handleCheckboxChange(event, row.alias, column.alias)}
                    />
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CustomTableContainer>
    </div>
  );
}

export default React.memo(withFormsy(TabularMultipleFormsy));
